import { DOCUMENT } from '@angular/common'
import { Component, inject, input, OnInit, TemplateRef } from '@angular/core'
import { FormControl, ReactiveFormsModule } from '@angular/forms'
import { MatOptionModule } from '@angular/material/core'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'
import { InputCellContainerComponent } from '@app/feature/input-cells/input-cell-container/input-cell-container.component'
import {
    CellContainerComponent,
    NEW_CONTAINER_CELLS,
} from '@app/shared/cell-types/cell-container.component'
import { TbInputComponent } from '@components-library/tb-input/tb-input.component'
import { AppRecord, Field, FieldType, FieldTypes } from '@core/models'
import { InputContainerAppearance } from '@models/input'
import { UntilDestroy } from '@ngneat/until-destroy'
import { Dictionary } from '@ngrx/entity'

@UntilDestroy()
@Component({
    selector: 'app-record-fields-input',
    templateUrl: './record-fields-input.component.html',
    imports: [
        MatFormFieldModule,
        MatSelectModule,
        MatOptionModule,
        ReactiveFormsModule,
        CellContainerComponent,
        TbInputComponent,
        InputCellContainerComponent,
        ReactiveFormsModule,
    ],
})
export class RecordFieldsInputComponent implements OnInit {
    private readonly document = inject<Document>(DOCUMENT)

    protected readonly FieldTypes = FieldTypes

    readonly field = input.required<Field>()
    readonly fieldTypes = input.required<Dictionary<FieldType>>()
    readonly fieldValueFormControl = input.required<FormControl<string | null>>()
    // need for link ref
    readonly record = input<AppRecord>()
    readonly inputAppearance = input(InputContainerAppearance.create_record)
    readonly hoverIcons = input<TemplateRef<any>>()

    isFieldNonText!: boolean
    supportNewContainer!: boolean

    ngOnInit() {
        this.isFieldNonText = this.isFieldNonTextCheck(this.field().field_type_code)
        this.supportNewContainer = this.hasNewContainerSupport(this.field().field_type_code)
    }

    cellValueChanged(value: string) {
        this.fieldValueFormControl().setValue(value)
    }

    private isFieldNonTextCheck(type: FieldTypes | string) {
        return [
            FieldTypes.STATUS,
            FieldTypes.DROPDOWN,
            FieldTypes.PEOPLE,
            FieldTypes.ASSIGNEE,
            FieldTypes.RATING,
            FieldTypes.BOOL,
            FieldTypes.DATE,
            FieldTypes.DATE_RANGE,
            FieldTypes.DATE_TIME,
            FieldTypes.LINK,
            FieldTypes.LINK_REFERENCE,
        ].includes(type as FieldTypes)
    }

    hasNewContainerSupport(type: FieldTypes | string) {
        return NEW_CONTAINER_CELLS.includes(type as FieldTypes)
    }

    updateOnEnter() {
        ;(this.document.activeElement as HTMLElement).blur()
    }
}
